export const scrollOptions: ScrollIntoViewOptions = {
  behavior: 'smooth',
  inline: 'center',
}
